import { BasicsClass } from "@/common/BasicsClass";


export class KTVOrderReserveUpdateRecordApi extends BasicsClass {

  public apiUrls: any = new Map([
    ['getReserveUpdateRecordList', {
        url: '/admin/ktvOrder/modifySubscribeLogger',
        name: 'reserve-update-record-list',
        label: '预约修改记录列表'
    }],

  ])

  // 订单预约修改记录 api 方法
  public getReserveUpdateRecordList(
    params: any,
    successCb: Function,
    failCb: Function,
    showLoading: boolean = false
  ) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getReserveUpdateRecordList').url

    this.BasicPost(url, {
        ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

}
